import { formatDate } from '@/lib/formatUtils';
import { ExcelColumnMapping } from './types';
import { STATUS_MAP } from './constant';

const toNumberFlag = (value: MuaHangRecord) => (value ? 1 : 0);

export const HOA_DON_MUA_HANG_TRONG_NUOC_COLUMNS: ExcelColumnMapping[] = [
  {
    header: 'Hoá đơn',
    width: 10,
    resolver: row => toNumberFlag(row?.hdmh_yn)
  },
  {
    header: 'Nhập kho',
    width: 10,
    resolver: row => toNumberFlag(row?.pn_yn)
  },
  {
    header: 'Xuất thẳng',
    width: 12,
    resolver: row => toNumberFlag(row?.xt_yn)
  },
  {
    header: 'Trạng thái',
    width: 16,
    resolver: row => STATUS_MAP[row?.status] || row?.status || ''
  },
  {
    header: 'Số c/từ',
    width: 18,
    resolver: row => row?.so_ct || ''
  },
  {
    header: 'Ngày c/từ',
    width: 16,
    resolver: row => formatDate(row?.ngay_ct)
  },
  {
    header: 'Số hóa đơn',
    width: 16,
    resolver: row => row?.so_ct0 || ''
  },
  {
    header: 'Mã khách hàng',
    width: 18,
    resolver: row => row?.ma_kh_data?.customer_code || row?.ma_kh || ''
  },
  {
    header: 'Tên khách hàng',
    width: 28,
    resolver: row => row?.ma_kh_data?.customer_name || row?.ten_kh_thue || ''
  },
  {
    header: 'Diễn giải',
    width: 40,
    resolver: row => row?.dien_giai || ''
  },
  {
    header: 'Tk có',
    width: 12,
    resolver: row => row?.tk_data?.code || row?.tk || ''
  },
  {
    header: 'Tổng tiền',
    width: 18,
    resolver: row => Number(row?.t_tt_nt || row?.t_tt || '')
  },
  {
    header: 'Ngoại tệ',
    width: 12,
    resolver: row => row?.ma_nt_data?.ma_nt || row?.ma_nt || ''
  },
  {
    header: 'Người tạo',
    width: 22,
    resolver: row => row?.created_by_full_name || row?.nguoi_tao || row?.created_by || ''
  },
  {
    header: 'Ngày tạo',
    width: 20,
    resolver: row => formatDate(row?.created_at || row?.ngay_tao)
  },
  {
    header: 'Người sửa',
    width: 22,
    resolver: row => row?.updated_by_full_name || row?.nguoi_sua || row?.updated_by || ''
  },
  {
    header: 'Ngày sửa',
    width: 20,
    resolver: row => formatDate(row?.updated_at || row?.ngay_sua)
  }
];
